import * as R from 'ramda'

import toLowerAndTrim from './toLowerAndTrim'

export default R.curry((prop) => R.pipe(R.propOr('', prop), toLowerAndTrim))
